import React, { Component } from 'react';
import { AppCollapsible } from '../AppCollapsible';
import { connect } from 'react-redux';
import { editInputWithProps } from '../../../redux/actions/inputWithProps';
import { AppInputWrapper } from '../AppInputWrapper';

const numberRegexp = /^\d+$/;

class Number extends Component {

    state = {
        label: this.props.initialValues.label || 'Number',
        placeholder: this.props.initialValues.placeholder || 'Type...',
        required: this.props.initialValues.isRequired || false,
        value: '',

        numberNotValidError: false,
        requiredError: this.props.initialValues.isRequired || false,
    };

    updateInputPropsInStore = () => {
        const { label, placeholder, required, value } = this.state;

        const inputProps = {
            label,
            isRequired: required,
            placeholder,
            type: this.props.initialValues.type,
            _value: +value,
            _hasValidationErrors: this.state.numberNotValidError || this.state.requiredError,
        };

        this.props.editInputWithProps(this.props.initialValues.id, inputProps);
    };

    componentDidMount() {
        setTimeout(_ => {
            this.updateInputPropsInStore();
        }, 500);
    }

    componentDidUpdate() {
        this.updateInputPropsInStore();
    }

    setLabel = (e) => {
        this.setState({ label: e.target.value })
    };

    setPlaceholder = (e) => {
        this.setState({ placeholder: e.target.value })
    };

    setRequired = (e) => {
        this.setState({ required: e.target.checked })
    };

    setNumberVal = (e) => {
        const value = e.target.value;
        this.setState({
            value,
            numberNotValidError: value !== '' && !numberRegexp.test(value)
        }, () => {
            this.updateRequiredError();
        });
    }

    updateRequiredError = () => {
        let requiredError;
        if (!this.state.required) {
            requiredError = false;
        } else {
            requiredError = !this.state.value;
        }

        this.setState({ requiredError });
    }

    render() {
        const { textColor, isResultInput } = this.props;
        return (
            <>
                <AppInputWrapper
                    label={this.state.label}
                    color={textColor}
                    required={this.state.required}
                    requiredError={this.state.requiredError}
                >
                    <>
                        <div
                            className="default-input-wrapper"
                            data-validation-error={this.state.numberNotValidError}
                        >
                            <input
                                className="default-input"
                                value={this.state.value}
                                placeholder={this.state.placeholder }
                                type="text"
                                onChange={this.setNumberVal}
                            />
                        </div>
                        {
                            this.state.numberNotValidError &&
                            <span className="validation-error-text">Not a number</span>
                        }
                    </>
                </AppInputWrapper>
                {
                    !isResultInput &&
                    <AppCollapsible>
                        <div className="settings-container">

                            <label>
                                <input value={this.state.label} onChange={this.setLabel} type="text"/>
                                label
                            </label>
                            <label>
                                <input value={this.state.placeholder} onChange={this.setPlaceholder} type="text"/>
                                placeholder
                            </label>
                            <label>
                                <input checked={this.state.required} onChange={this.setRequired} type="checkbox"/>
                                required
                            </label>
                        </div>
                    </AppCollapsible>
                }
            </>
        );
    }
}

export default connect(
    () => ({}),
    {
        editInputWithProps
    }
)(Number);